<template>
  <img
    :src="getImage(item)"
    :class="{ 'image-placeholder': ! hasBaseImage(item.product) }"
    alt="product image"
    @error="handleImageError"
  >
</template>

<script>
import DefaultImageMixin from "@core/mixin/DefaultImageMixin";

export default {
  name: "CartImage",
  mixins: [DefaultImageMixin],
  props: ['item']
}
</script>

<style scoped>

</style>
